<template>
  <v-select
    label="Reporting Increments"
    :items="items"
    item-text="text"
    item-value="value"
    v-model="selected"
    @change="updateInterval"
  ></v-select>
</template>

<script>
export default {
  name: "IntervalSelector",
  data() {
    return {
      selected: this.$store.state.Dashboard.widgetConfig.intervalType,
      items: [
        {
          text: '1',
          value: '1'
        },
        {
          text: '2',
          value: '2'
        },
        {
          text: '3',
          value: '3'
        },
        {
          text: '4',
          value: '4'
        },
        {
          text: '5',
          value: '5'
        },
        {
          text: '6',
          value: '6'
        },
        {
          text: '7',
          value: '7'
        },
      ]
    }
  },
  methods: {
    updateInterval(event) {
      this.$store.commit('setIntervalType', event );
      this.$emit('period-changed', event);
    }
  },
  mounted: {

  }
}
</script>

<style scoped>

</style>
